import React, { forwardRef } from "react";
import PrintText from "../manageprint/components/PrintText";

type BillProps = {
  customerName: string;
  item: { name: string; price: number; qty: number }[]; // Type for item
  total: number;
};


const Bill = forwardRef<HTMLDivElement, BillProps>(({ customerName, item, total }, ref) => {
  const date: Date = new Date();
  const currentTime = date.toLocaleTimeString();

  const items = {
    container: {
      top: 530,
      left: 302,
      show: true,
      size: 50,
      title: 'container',
      name: 'container',
      identifiyer: 'container',
    },
    logo: {
      top: 5,
      left: 214,
      show: true,
      size: 30,
      title: 'logo',
      name: 'clinic Logo',
      identifiyer: 'logo',
    },
    header: {
      top: 21,
      left: 100,
      show: true,
      size: 40,
      title: 'DEMO',
      name: 'Title',
      identifiyer: 'header',
    },
    address: {
      top: 75,
      left: 75,
      show: true,
      size: 13,
      title: '154, HILL STREET, DEHIWALA',
      name: 'Address',
      identifiyer: 'address',
    },
    phonetext: {
      top: 90,
      left: 103,
      show: true,
      size: 13,
      title: 'TEL : ',
      name: 'Phone Number text',
      identifiyer: 'phonetext',
    },
    phone: {
      top: 90,
      left: 137,
      show: true,
      size: 13,
      title: '075 123 4567',
      name: 'Phone Number',
      identifiyer: 'phone',
    },
    emailText: {
      top: 104,
      left: 85,
      show: true,
      size: 13,
      title: 'EMAIL : ',
      name: 'Email Address Text',
      identifiyer: 'emailText',
    },
    eamilNumber: {
      top: 104,
      left: 136,
      show: true,
      size: 13,
      title: 'demo@email.com',
      name: 'Email Address',
      identifiyer: 'eamilNumber',
    },
    date: {
      top: 120,
      left: 15,
      show: true,
      size: 13,
      title: 'DATE',
      name: 'Date',
      identifiyer: 'date',
    },
    time: {
      top: 120,
      left: 81,
      show: true,
      size: 13,
      title: 'TIME',
      name: 'Time',
      identifiyer: 'time',
    },
    orderNo: {
      top: 120,
      left: 238,
      show: true,
      size: 13,
      title: 'R: ',
      name: 'Order Number Text',
      identifiyer: 'orderNo',
    },
    orderNumber: {
      top: 120,
      left: 252,
      show: true,
      size: 13,
      title: '003456',
      name: 'Order Number',
      identifiyer: 'orderNumber',
    },
    cashier: {
      top: 120,
      left: 155,
      show: false,
      size: 13,
      title: 'C:',
      name: 'Cashier Text',
      identifiyer: 'cashier',
    },
    cashierName: {
      top: 121,
      left: 168,
      show: true,
      size: 13,
      title: 'RAFSHAN',
      name: 'Cashier Name',
      identifiyer: 'cashierName',
    },
    seriNo: {
      top: 140,
      left: 2,
      show: true,
      size: 13,
      title: 'LN',
      name: 'Serial Number Text',
      identifiyer: 'seriNo',
    },
    pluNumber: {
      top: 140,
      left: 45,
      show: true,
      size: 13,
      title: 'PLU.',
      name: 'PLU Text',
      identifiyer: 'pluNumber',
    },
    itemCode: {
      top: 140,
      left: 110,
      show: true,
      size: 13,
      title: 'ITEM',
      name: 'ITEM CODE',
      identifiyer: 'itemCode',
    },
    discription: {
      top: 170,
      left: 170,
      show: true,
      size: 13,
      title: 'DISCRIPTION',
      name: 'item discription Text',
      identifiyer: 'discription',
    },
    quantity: {
      top: 155,
      left: 2,
      show: true,
      size: 13,
      title: 'QTY',
      name: 'Quantity text',
      identifiyer: 'quantity',
    },
    rate: {
      top: 155,
      left: 50,
      show: true,
      size: 13,
      title: 'RATE',
      name: 'Rate text',
      identifiyer: 'rate',
    },
    gross: {
      top: 155,
      left: 120,
      show: true,
      size: 13,
      title: 'GROSS',
      name: 'gross text',
      identifiyer: 'gross',
    },
    discount: {
      top: 155,
      left: 200,
      show: true,
      size: 13,
      title: 'DIS%',
      name: 'discount text',
      identifiyer: 'discount',
    },
    netAmount: {
      top: 155,
      left: 240,
      show: true,
      size: 13,
      title: 'NET AMT',
      name: 'Net Amount Text',
      identifiyer: 'netAmount',
    },
    shopingDetail: {
      top: 175,
      left: 2,
      show: true,
      size: 295,
      title: 'treatmentDetail',
      name: 'Item Details Table',
      identifiyer: 'shopingDetail',
    },
    totalDetails: {
      top: 245,
      left: 2,
      show: true,
      size: 295,
      title: 'treatmentDetail',
      name: 'Total Details Table',
      identifiyer: 'totalDetails',
    },
    paymentDetaiils: {
      top: 300,
      left: 2,
      show: true,
      size: 295,
      title: 'Payment detailes',
      name: 'payment Details Table',
      identifiyer: 'paymentDetaiils',
    },
    changeText: {
      top: 360,
      left: 2,
      show: true,
      size: 13,
      title: 'Change',
      name: 'Change Text',
      identifiyer: 'changeText',
    },
    change: {
      top: 360,
      left: 260,
      show: true,
      size: 13,
      title: '200.00',
      name: 'Change Amount',
      identifiyer: 'change',
    },
    changeamountText: {
      top: 375,
      left: 2,
      show: true,
      size: 13,
      title: 'Change In Cash',
      name: 'Change In cash Text',
      identifiyer: 'changeamountText',
    },
    changeamount: {
      top: 375,
      left: 260,
      show: true,
      size: 13,
      title: '100.00',
      name: 'Change In Cash Amount',
      identifiyer: 'changeamount',
    },
    horizontallineone: {
      top: 135,
      left: 0,
      show: true,
      size: 550,
      name: 'Horizondal Line 1',
      identifiyer: 'horizontallineone',
    },
    horizontallinetwo: {
      top: 172,
      left: 0,
      show: true,
      size: 550,
      name: 'Horizondal Line 2',
      identifiyer: 'horizontallinetwo',
    },
    horizontallinethree: {
      top: 240,
      left: 0,
      show: true,
      size: 550,
      name: 'Horizondal Line 3',
      identifiyer: 'horizontallinethree',
    },
    horizontallinefour: {
      top: 243,
      left: 0,
      show: true,
      size: 550,
      name: 'Horizondal Line 4',
      identifiyer: 'horizontallinefour',
    },
    horizontallinefive: {
      top: 352,
      left: 0,
      show: true,
      size: 550,
      name: 'Horizondal Line 5',
      identifiyer: 'horizontallinefive',
    },
    horizontallinesix: {
      top: 395,
      left: 0,
      show: true,
      size: 550,
      name: 'Horizondal Line 6',
      identifiyer: 'horizontallinesix',
    },
    horizontallineseven: {
      top: 465,
      left: 0,
      show: true,
      size: 550,
      name: 'Horizondal Line 6',
      identifiyer: 'horizontallineseven',
    },
    massage: {
      top: 425,
      left: 100,
      show: true,
      size: 15,
      name: 'massage',
      identifiyer: 'massage',
    },
    promotion: {
      top: 456,
      left: 175,
      show: true,
      size: 7,
      name: 'massage',
      identifiyer: 'promotion',
    },
    wish: {
      top: 475,
      left: 70,
      show: true,
      size: 15,
      title: 'Thank You! Come Again!',
      name: 'Thank You Text',
      identifiyer: 'wish',
    },
  };
  return (
    <div ref={ref} style={{ padding: "20px", fontFamily: "monospace" }}>
      <div style={{ all: "revert" }} className="bill_preview_container"  >
        <div
          style={{
            border: "1px solid black",
            width: 302,
            overflow: "hidden",
            padding: 10,
            position: "relative",
            height: 530,
            fontFamily: 'BitMatrix-B1'
          }}
          className="bill_prewiew">
          <p
            style={{
              position: "absolute",
              whiteSpace: "nowrap",
              top: 21,
              left: 100,
              fontSize: 40,
              textTransform: "uppercase",
              // fontWeight: 600,
            }}
          >
            DEMO
          </p>
          <div
            style={{
              all: "unset",
              position: "absolute",
              whiteSpace: "nowrap",
              top: 5,
              left: 214,
              fontSize: 30,
              border: "1px solid black",

            }}
          >LOGO</div>

          <PrintText items={items?.address} title={items?.address?.title} />
          <PrintText items={items?.phonetext} title={items?.phonetext?.title} />
          <PrintText items={items?.phone} title={items?.phone?.title} />
          <PrintText items={items?.emailText} title={items?.emailText?.title} />
          <PrintText items={items?.eamilNumber} title={items?.eamilNumber?.title} />
          <PrintText items={items?.seriNo} title={items?.seriNo?.title} />
          <PrintText items={items?.pluNumber} title={items?.pluNumber?.title} />
          <PrintText items={items?.itemCode} title={items?.itemCode?.title} />
          <PrintText items={items?.quantity} title={items?.quantity?.title} />
          <PrintText items={items?.rate} title={items?.rate?.title} />
          <PrintText items={items?.gross} title={items?.gross?.title} />
          <PrintText items={items?.discount} title={items?.discount?.title} />
          <PrintText items={items?.netAmount} title={items?.netAmount?.title} />

          <hr style={{
            borderTop: "2px dotted black",
            height: 3,
            position: "absolute",
            top: items?.horizontallineone?.top,
            left: items?.horizontallineone?.left,
            width: items?.horizontallineone?.size,
            display: items?.horizontallineone?.show ? "" : "none",
          }} />

          <PrintText
            items={items?.date}
            title={date?.toLocaleDateString("en-GB")}
          />
          <PrintText
            items={items?.time}
            title={currentTime}
          />
          <PrintText items={items?.orderNo} title={items?.orderNo?.title} />
          <PrintText items={items?.orderNumber} title={items?.orderNumber?.title} />
          <PrintText items={items?.cashier} title={items?.cashier?.title} />
          <PrintText items={items?.cashierName} title={items?.cashierName?.title} />

          {/* 2nd line */}
          <hr style={{
            borderTop: "2px dotted black",
            height: 3,
            position: "absolute",
            top: items?.horizontallinetwo?.top,
            left: items?.horizontallinetwo?.left,
            width: items?.horizontallinetwo?.size,
            display: items?.horizontallinetwo?.show ? "" : "none",
          }} />

          {/* 3rd line */}
          <hr style={{
            borderTop: "2px dotted black",
            height: 3,
            position: "absolute",
            top: items?.horizontallinethree?.top,
            left: items?.horizontallinethree?.left,
            width: items?.horizontallinethree?.size,
            display: items?.horizontallinethree?.show ? "" : "none",
          }} />


          {/* <table
            style={{
              position: "absolute",
              top: items?.shopingDetail?.top,
              left: items?.shopingDetail?.left,
              width: items?.shopingDetail?.size,
              display: items?.shopingDetail?.show ? "" : "none",
            }}
          > */}

          {/* <tbody style={{ textAlign: "center", fontSize: "13px", textTransform: "uppercase" }}> */}
          {/* <tr > */}
          <div
            style={{
              position: "absolute",
              top: items?.shopingDetail?.top,
              left: items?.shopingDetail?.left,
              width: items?.shopingDetail?.size,
              display: items?.shopingDetail?.show ? "" : "none",
            }}
          >

            <div style={{ display: "grid", gridTemplateColumns: "20px 80px 1fr 1fr", textAlign: "start" }}>
              <td style={{ width: "20px"}}>1</td>
              <td >00000037</td>
              <td >Chocolate milk 750ml  </td>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "20px 1fr 1fr 1fr 1fr", textAlign: "end" }}>
              <td style={{ width: "20px", textAlign: "start", all: "unset" }}>3.0</td>
              <td style={{ all: "unset" }}>1200.00</td>
              <td >3600.00</td>
              <td >0.0</td>
              <td >48000.00</td>
            </div>

            {/* </tr> */}
            {/* <tr style={{ all: "revert" }}> */}
            <div style={{ display: "grid", gridTemplateColumns: "20px 80px 1fr 1fr", textAlign: "start" }}>
              <td style={{ width: "20px" }}>2</td>
              <td >00000456</td>
              <td style={{ gridColumn: "3 / span 2" }}>Chocolate milk 750ml  </td>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "20px 1fr 1fr 1fr 1fr", textAlign: "end" }}>
              <td style={{ width: "20px", textAlign: "start" }}>6.0</td>
              <td >1400.00</td>
              <td >4200.00</td>
              <td >100.00</td>
              <td >56000.00</td>
            </div>

            {/* </tr> */}
          </div>

          {/* 
            </tbody>
          </table> */}

          {/* 4th line */}
          <hr style={{
            borderTop: "1px dotted black",
            height: 1,
            position: "absolute",
            top: items?.horizontallinefour?.top,
            left: items?.horizontallinefour?.left,
            width: items?.horizontallinefour?.size,
            display: items?.horizontallinefour?.show ? "" : "none",
          }} />

          {/* 5th line */}
          <hr style={{
            borderTop: "2px dotted black",
            height: 3,
            position: "absolute",
            top: items?.horizontallinefive?.top,
            left: items?.horizontallinefive?.left,
            width: items?.horizontallinefive?.size,
            display: items?.horizontallinefive?.show ? "" : "none",
          }} />

          {/* total table */}
          <table
            style={{
              all: "revert",
              position: "absolute",
              top: items?.totalDetails?.top,
              left: items?.totalDetails?.left,
              width: items?.totalDetails?.size,
              display: items?.totalDetails?.show ? "" : "none",
            }}
          >
            <tbody style={{ fontSize: "13px", all: "revert" }}>
              <tr style={{ all: "revert" }}>
                <td style={{ textAlign: "start" }}>Gross Amount</td>
                <td style={{ textAlign: "end" }}>200.00</td>
              </tr>
              <tr style={{ all: "revert" }}>
                <td style={{ textAlign: "start" }}>Totel Discount</td>
                <td style={{ textAlign: "end" }}>200.00</td>
              </tr>
              <tr style={{ all: "revert" }}>
                <td style={{ textAlign: "start" }}>Net Amount</td>
                <td style={{ textAlign: "end" }}>10.00</td>
              </tr>

            </tbody>
          </table>

          {/* payment table */}
          <table
            style={{
              all: "revert",
              position: "absolute",
              top: items?.paymentDetaiils?.top,
              left: items?.paymentDetaiils?.left,
              width: items?.paymentDetaiils?.size,
              display: items?.paymentDetaiils?.show ? "" : "none",
            }}
          >
            <tbody style={{ all: "revert", fontSize: "13px" }}>

              <tr style={{ all: "revert" }}>
                <td style={{ textAlign: "start" }}>Cash</td>
                <td style={{ textAlign: "end" }}>190.00</td>
              </tr>
              <tr style={{ all: "revert" }}>
                <td style={{ textAlign: "start" }}>Card</td>
                <td style={{ textAlign: "end" }}>190.00</td>
              </tr>
              <tr style={{ all: "revert" }}>
                <td style={{ textAlign: "start" }}>Bank Transfer</td>
                <td style={{ textAlign: "end" }}>190.00</td>
              </tr>

            </tbody>
          </table>
          <PrintText items={items?.changeText} title={items?.changeText?.title} />
          <PrintText items={items?.change} title={items?.change?.title} />
          <PrintText items={items?.changeamountText} title={items?.changeamountText?.title} />
          <PrintText items={items?.changeamount} title={items?.changeamount?.title} />

          {/* 6th line */}
          <hr style={{
            borderTop: "2px dotted black",
            position: "absolute",
            top: items?.horizontallinesix?.top,
            left: items?.horizontallinesix?.left,
            width: items?.horizontallinesix?.size,
            display: items?.horizontallinesix?.show ? "" : "none",
          }} />
          {/* 7th line */}
          <hr style={{
            borderTop: "2px dotted black",
            position: "absolute",
            top: items?.horizontallineseven?.top,
            left: items?.horizontallineseven?.left,
            width: items?.horizontallineseven?.size,
            display: items?.horizontallineseven?.show ? "" : "none",
          }} />

          <PrintText items={items?.wish} title={items?.wish?.title} />
          {/* <PrintText items={items?.massage} title={items?.massage?.title} /> */}

          <div>
            <p
              style={{
                position: "absolute",
                top: items?.massage?.top,
                left: items?.massage?.left,
                fontSize: items?.massage?.size,

              }}
            >
              MESSAGE
            </p>

          </div>
          <div>
            <p
              style={{
                position: "absolute",
                top: items?.promotion?.top,
                left: items?.promotion?.left,
                fontSize: items?.promotion?.size,
                // border: "1px solid black",

              }}
            >
              https://pos.cholasys.com   +9477 123 4567

            </p>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Bill;
